<template>
    <div class="stats-item-component"
         v-if="value">
        <p v-html="label"></p>
        <p v-html="value + ' FTO'"></p>
    </div>
</template>

<script>
    export default {
        props: ['label', 'value']
    }
</script>

<style lang="scss">
    @import '../../../../../../../assets/scss/_colors.scss';

    .stats-item-component{
        height: 80px;
        padding-bottom: 6px;
        border-bottom: 6px solid $base1;
        margin-bottom: 11px;
    }

    @media(max-width:991px){
        .stats-item-component{
            height: auto;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/futurocoin/futurocoin-stats/StatsItem.vue